export enum AuthorizationDetailTitle {
    GENERAL_INFO = "GENERAL INFO",
    REQUEST_DETAILS = "REQUEST DETAILS",
    INBOUND_DOCUMENTATION = "INBOUND DOCUMENTATION",
    NOTES = "NOTES",
    LETTER_DECISION = "LETTER & DECISION NOTIFICATIONS",
}

export const HeaderLabel = [
    { label: AuthorizationDetailTitle.GENERAL_INFO, fontWeight: 500 },
    { label: AuthorizationDetailTitle.REQUEST_DETAILS, fontWeight: 500 },
    { label: AuthorizationDetailTitle.INBOUND_DOCUMENTATION, fontWeight: 500 },
    { label: AuthorizationDetailTitle.NOTES, fontWeight: 500 },
    { label: AuthorizationDetailTitle.LETTER_DECISION, fontWeight: 500 },
];

export const NoteHeaderLabel = [
  { label: "DATE/TIME", width: "30%" },
  { label: "COMMUNICATION TYPE", width: "50%" },
  { label: "", width: "20%" },
];


export enum GeneralInfoActionDispatchTypes {
  GENERAL_INFO_INVOKE = "GENERAL_INFO_INVOKE",
  GENERAL_INFO_SUCCESS = "GENERAL_INFO_SUCCESS",
  GENERAL_INFO_ERROR = "GENERAL_INFO_ERROR",
  GENERAL_INFO_RESET = "GENERAL_INFO_RESET"
}

export enum RequestDetailsActionDispatchTypes {
  REQUEST_DETAILS_INVOKE = "REQUEST_DETAILS_INVOKE",
  REQUEST_DETAILS_SUCCESS = "REQUEST_DETAILS_SUCCESS",
  REQUEST_DETAILS_ERROR = "REQUEST_DETAILS_ERROR",
  REQUEST_DETAILS_RESET = "REQUEST_DETAILS_RESET"
}

export enum NotesListActionDispatchTypes {
  NOTES_LIST_INVOKE = "NOTES_LIST_INVOKE",
  NOTES_LIST_SUCCESS = "NOTES_LIST_SUCCESS",
  NOTES_LIST_ERROR = "NOTES_LIST_ERROR",
  NOTES_LIST_RESET = "NOTES_LIST_RESET"
}

export enum NotesViewActionDispatchTypes {
  NOTES_VIEW_INVOKE = "NOTES_VIEW_INVOKE",
  NOTES_VIEW_SUCCESS = "NOTES_VIEW_SUCCESS",
  NOTES_VIEW_ERROR = "NOTES_VIEW_ERROR",
  NOTES_VIEW_RESET = "NOTES_VIEW_RESET"
}

export enum AuthorizationHistoryDispatchTypes {
  GET_AUTH_HISTORY_ERROR = "GET_AUTH_HISTORY_ERROR",
  GET_AUTH_HISTORY_INVOKE = "GET_AUTH_HISTORY_INVOKE",
  GET_AUTH_HISTORY_SUCCESS = "GET_AUTH_HISTORY_SUCCESS",
}
